var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "main"
  }, [_c('a-form', {
    ref: "formLogin",
    staticClass: "user-layout-login",
    attrs: {
      "form": _vm.form,
      "id": "formLogin"
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['username', {
        initialValue: '',
        rules: _vm.validatorRules.username.rules
      }],
      expression: "[\n              'username',\n              { initialValue: '', rules: validatorRules.username.rules },\n            ]"
    }],
    attrs: {
      "size": "large",
      "type": "text",
      "placeholder": "姓名"
    }
  }, [_c('a-icon', {
    style: {
      color: 'rgba(0,0,0,.25)'
    },
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password', {
        initialValue: '',
        rules: _vm.validatorRules.password.rules
      }],
      expression: "[\n              'password',\n              {\n                initialValue: '',\n                rules: validatorRules.password.rules,\n              },\n            ]"
    }],
    attrs: {
      "size": "large",
      "type": "text",
      "autocomplete": "false",
      "placeholder": "身份证号"
    }
  }, [_c('a-icon', {
    style: {
      color: 'rgba(0,0,0,.25)'
    },
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _c('a-form-item', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('a-button', {
    staticClass: "login-button",
    attrs: {
      "size": "large",
      "type": "primary",
      "htmlType": "submit",
      "loading": _vm.loginBtn,
      "readOnly": _vm.loginBtn
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v("确定\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };